// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               unknown
// source: photon/imessage/v1/message_types.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp.js";
import { SingleServiceAddressInfo } from "./address_types.js";
import { AttachmentInfo } from "./attachment_types.js";

export const protobufPackage = "photon.imessage.v1";

/**
 * Discriminates regular messages from the synthetic "system" rows Apple
 * uses to record chat lifecycle changes.
 *
 * Wire values mirror chat.db `message.item_type`.
 *
 * `0` is a real "normal" value, not "unspecified".
 */
export enum MessageItemType {
  MESSAGE_ITEM_TYPE_NORMAL = 0,
  MESSAGE_ITEM_TYPE_PARTICIPANT_CHANGE = 1,
  MESSAGE_ITEM_TYPE_GROUP_NAME_CHANGE = 2,
  MESSAGE_ITEM_TYPE_CHAT_ACTION = 3,
  UNRECOGNIZED = -1,
}

export function messageItemTypeFromJSON(object: any): MessageItemType {
  switch (object) {
    case 0:
    case "MESSAGE_ITEM_TYPE_NORMAL":
      return MessageItemType.MESSAGE_ITEM_TYPE_NORMAL;
    case 1:
    case "MESSAGE_ITEM_TYPE_PARTICIPANT_CHANGE":
      return MessageItemType.MESSAGE_ITEM_TYPE_PARTICIPANT_CHANGE;
    case 2:
    case "MESSAGE_ITEM_TYPE_GROUP_NAME_CHANGE":
      return MessageItemType.MESSAGE_ITEM_TYPE_GROUP_NAME_CHANGE;
    case 3:
    case "MESSAGE_ITEM_TYPE_CHAT_ACTION":
      return MessageItemType.MESSAGE_ITEM_TYPE_CHAT_ACTION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MessageItemType.UNRECOGNIZED;
  }
}

export function messageItemTypeToJSON(object: MessageItemType): string {
  switch (object) {
    case MessageItemType.MESSAGE_ITEM_TYPE_NORMAL:
      return "MESSAGE_ITEM_TYPE_NORMAL";
    case MessageItemType.MESSAGE_ITEM_TYPE_PARTICIPANT_CHANGE:
      return "MESSAGE_ITEM_TYPE_PARTICIPANT_CHANGE";
    case MessageItemType.MESSAGE_ITEM_TYPE_GROUP_NAME_CHANGE:
      return "MESSAGE_ITEM_TYPE_GROUP_NAME_CHANGE";
    case MessageItemType.MESSAGE_ITEM_TYPE_CHAT_ACTION:
      return "MESSAGE_ITEM_TYPE_CHAT_ACTION";
    case MessageItemType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Tapback families understood by Apple's Messages stack.
 *
 * `EMOJI` and `STICKER` are the post-iOS 18 generic carriers; the wrapped
 * value is delivered out-of-band (`MessageReaction.emoji` for emoji
 * tapbacks, the associated message itself for sticker tapbacks).
 *
 * Wire values are transport-internal. Apple stores tapback kind in a composite
 * `associated_message_type` column, not as a direct integer match for these
 * tags.
 */
export enum MessageReactionKind {
  MESSAGE_REACTION_KIND_LOVE = 0,
  MESSAGE_REACTION_KIND_LIKE = 1,
  MESSAGE_REACTION_KIND_DISLIKE = 2,
  MESSAGE_REACTION_KIND_LAUGH = 3,
  MESSAGE_REACTION_KIND_EMPHASIZE = 4,
  MESSAGE_REACTION_KIND_QUESTION = 5,
  MESSAGE_REACTION_KIND_EMOJI = 6,
  /**
   * MESSAGE_REACTION_KIND_STICKER - Carrier for sticker tapbacks.
   *
   * The placed sticker arrives as its own attachment row, not as a
   * `MessageReaction`. Servers reject `SetReaction` calls that pass
   * `STICKER`; use `PlaceSticker` instead.
   */
  MESSAGE_REACTION_KIND_STICKER = 7,
  UNRECOGNIZED = -1,
}

export function messageReactionKindFromJSON(object: any): MessageReactionKind {
  switch (object) {
    case 0:
    case "MESSAGE_REACTION_KIND_LOVE":
      return MessageReactionKind.MESSAGE_REACTION_KIND_LOVE;
    case 1:
    case "MESSAGE_REACTION_KIND_LIKE":
      return MessageReactionKind.MESSAGE_REACTION_KIND_LIKE;
    case 2:
    case "MESSAGE_REACTION_KIND_DISLIKE":
      return MessageReactionKind.MESSAGE_REACTION_KIND_DISLIKE;
    case 3:
    case "MESSAGE_REACTION_KIND_LAUGH":
      return MessageReactionKind.MESSAGE_REACTION_KIND_LAUGH;
    case 4:
    case "MESSAGE_REACTION_KIND_EMPHASIZE":
      return MessageReactionKind.MESSAGE_REACTION_KIND_EMPHASIZE;
    case 5:
    case "MESSAGE_REACTION_KIND_QUESTION":
      return MessageReactionKind.MESSAGE_REACTION_KIND_QUESTION;
    case 6:
    case "MESSAGE_REACTION_KIND_EMOJI":
      return MessageReactionKind.MESSAGE_REACTION_KIND_EMOJI;
    case 7:
    case "MESSAGE_REACTION_KIND_STICKER":
      return MessageReactionKind.MESSAGE_REACTION_KIND_STICKER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MessageReactionKind.UNRECOGNIZED;
  }
}

export function messageReactionKindToJSON(object: MessageReactionKind): string {
  switch (object) {
    case MessageReactionKind.MESSAGE_REACTION_KIND_LOVE:
      return "MESSAGE_REACTION_KIND_LOVE";
    case MessageReactionKind.MESSAGE_REACTION_KIND_LIKE:
      return "MESSAGE_REACTION_KIND_LIKE";
    case MessageReactionKind.MESSAGE_REACTION_KIND_DISLIKE:
      return "MESSAGE_REACTION_KIND_DISLIKE";
    case MessageReactionKind.MESSAGE_REACTION_KIND_LAUGH:
      return "MESSAGE_REACTION_KIND_LAUGH";
    case MessageReactionKind.MESSAGE_REACTION_KIND_EMPHASIZE:
      return "MESSAGE_REACTION_KIND_EMPHASIZE";
    case MessageReactionKind.MESSAGE_REACTION_KIND_QUESTION:
      return "MESSAGE_REACTION_KIND_QUESTION";
    case MessageReactionKind.MESSAGE_REACTION_KIND_EMOJI:
      return "MESSAGE_REACTION_KIND_EMOJI";
    case MessageReactionKind.MESSAGE_REACTION_KIND_STICKER:
      return "MESSAGE_REACTION_KIND_STICKER";
    case MessageReactionKind.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface MessageReaction {
  kind: MessageReactionKind;
  emoji?: string | undefined;
}

/** `@`-mention into a UTF-16 range of the message text. */
export interface MessageMention {
  address: string;
  start: number;
  length: number;
}

/**
 * Inline rich-text run (bold, italic, expressive effect) over a UTF-16
 * range of the parent text.
 */
export interface TextFormat {
  type: string;
  start: number;
  length: number;
  effectName?: string | undefined;
}

/**
 * Reference to an attachment by either its server-local on-disk path or
 * its GUID.
 */
export interface AttachmentRef {
  attachmentPath?: string | undefined;
  attachmentGuid?: string | undefined;
  attachmentName?: string | undefined;
}

/**
 * Pointer to the message being replied to. `target_part_index` selects a
 * single bubble in a multipart message; absent means the whole message.
 */
export interface ReplyTarget {
  messageGuid: string;
  targetPartIndex?: number | undefined;
}

/**
 * Spatial placement of a sticker on its target bubble. All values are in
 * Apple's normalised coordinate space.
 */
export interface StickerPlacement {
  x: number;
  y: number;
  scale?: number | undefined;
  rotation?: number | undefined;
  width?: number | undefined;
}

/**
 * One bubble in an outgoing multipart send. Exactly one of `text` or
 * `attachment` is set per part; mentions and formatting apply to `text`.
 */
export interface MessagePart {
  text?: string | undefined;
  attachment?: AttachmentRef | undefined;
  mentionedAddress?: string | undefined;
  bubbleIndex?: number | undefined;
  formatting: TextFormat[];
}

/**
 * Rendered content of an inbound or persisted message, with attachments,
 * mentions, and effects.
 */
export interface MessageContent {
  text?: string | undefined;
  attachments: AttachmentInfo[];
  formatting: TextFormat[];
  mentions: MessageMention[];
  balloonBundleId?: string | undefined;
  expressiveSendStyleId?: string | undefined;
}

/**
 * One currently-applied reaction folded onto its target message from an
 * associated tapback row.
 */
export interface MessageAppliedReaction {
  messageGuid: string;
  targetPartIndex?: number | undefined;
  reaction: MessageReaction | undefined;
  sender?: SingleServiceAddressInfo | undefined;
  isFromMe: boolean;
  dateCreated: Date | undefined;
}

/**
 * One sticker currently placed onto its target message from an associated
 * sticker row.
 */
export interface MessagePlacedSticker {
  messageGuid: string;
  targetPartIndex?: number | undefined;
  sender?: SingleServiceAddressInfo | undefined;
  isFromMe: boolean;
  dateCreated: Date | undefined;
  sticker?: AttachmentInfo | undefined;
  placement?: StickerPlacement | undefined;
}

/**
 * Canonical projection of a row in chat.db's `message` table, joined with
 * its attachments and any associated tapback.
 */
export interface Message {
  guid: string;
  content: MessageContent | undefined;
  subject?: string | undefined;
  dateCreated: Date | undefined;
  dateRead?: Date | undefined;
  dateDelivered?: Date | undefined;
  dateEdited?: Date | undefined;
  dateRetracted?: Date | undefined;
  datePlayed?: Date | undefined;
  dateExpressiveSendPlayed?: Date | undefined;
  sender?: SingleServiceAddressInfo | undefined;
  isFromMe: boolean;
  isSent: boolean;
  isDelivered: boolean;
  /** Monterey+. Delivered without firing a recipient notification. */
  isDeliveredQuietly: boolean;
  /**
   * Monterey+. The recipient's device was actually woken to surface the
   * message. Pair with `is_delivered_quietly` to distinguish silent vs
   * notified delivery.
   */
  didNotifyRecipient: boolean;
  /**
   * Apple's internal send-error code (0 = no error). Distinct from any
   * gRPC error returned for the RPC itself.
   */
  sendErrorCode: number;
  isAudioMessage: boolean;
  isAutoReply: boolean;
  /** Synthetic system row (e.g. "iMessage activated", group name change). */
  isSystemMessage: boolean;
  /**
   * Mirrors chat.db `message.is_forward`. Set on Continuity SMS-forwarded
   * rows and a handful of Apple-internal forwarding paths; rarely true
   * on iMessage traffic.
   */
  isForward: boolean;
  /**
   * Mirrors chat.db `message.is_delayed`. Set on rows queued for
   * scheduled delivery (iOS 18 "Send Later"); cleared once Apple
   * dispatches the send.
   */
  isDelayed: boolean;
  /**
   * Mirrors chat.db `message.is_spam`. Apple sets this on rows its
   * junk filter has classified as spam; user-visible state is
   * controlled at chat scope via `Chat.is_filtered`.
   */
  isSpam: boolean;
  /**
   * Apple's data detectors found URLs / phone numbers / addresses in
   * the body.
   */
  dataDetectorResultsPresent: boolean;
  /**
   * Mirrors chat.db `message.is_archive`. Per-row archival flag,
   * distinct from the chat-level `Chat.is_archived` view state. Set
   * on individual messages Apple has hidden from default queries.
   */
  isArchived: boolean;
  /** Carrier or platform service message (e.g. SMS billing notice). */
  isServiceMessage: boolean;
  /** chat.db reports the row as corrupt; content fields may be partial. */
  isCorrupt: boolean;
  /** Disappearing / ephemeral message that will expire client-side. */
  isExpirable: boolean;
  /**
   * Name-and-photo sharing status. `0` = not shared, `1` = shared. Raw
   * mirror of Apple's column; promoted to a typed enum is future work.
   */
  shareStatus?:
    | number
    | undefined;
  /**
   * Name-and-photo sharing direction. `0` = received from peer, `1` =
   * sent by local user.
   */
  shareDirection?: number | undefined;
  itemType: MessageItemType;
  /**
   * Set on `MESSAGE_ITEM_TYPE_GROUP_NAME_CHANGE` rows: the new group
   * title.
   */
  groupTitle?:
    | string
    | undefined;
  /**
   * Subtype for `MESSAGE_ITEM_TYPE_CHAT_ACTION` rows (Apple private
   * schema). Promoted to a typed enum is future work; see
   * domain `ChatActionType`.
   */
  chatActionType?:
    | number
    | undefined;
  /**
   * Apple's `thread_originator_guid` (BigSur+): GUID of the message
   * that started this reply thread. Reliable indicator of a public
   * threaded reply.
   */
  threadOriginatorGuid?:
    | string
    | undefined;
  /**
   * Apple's `thread_originator_part`: opaque part locator within the
   * originator (string form, e.g. `0:0/0`).
   */
  threadOriginatorPart?:
    | string
    | undefined;
  /**
   * Raw Apple `reply_to_guid` storage column. Frequently populated on
   * ordinary non-reply messages and may point at unrelated rows;
   * surface for diagnostics only. Prefer `reply_target_guid` to
   * determine a real reply.
   */
  replyToGuid?:
    | string
    | undefined;
  /**
   * Canonical public reply target. Set iff `thread_originator_guid` is
   * a reliable public threaded-reply target (non-self, non-empty).
   */
  replyTargetGuid?:
    | string
    | undefined;
  /**
   * The local Caller ID (phone / email) the message was sent from or
   * delivered to. Apple uses `e:` / `p:` prefixes.
   */
  destinationCallerId?:
    | string
    | undefined;
  /** Ventura+. Number of bubble parts in a multipart message. */
  partCount?:
    | number
    | undefined;
  /**
   * Denormalized group chat name cached on the message row by Apple
   * ("room" is Apple's internal term for what surface APIs call a
   * chat).
   */
  cachedRoomNames?:
    | string
    | undefined;
  /**
   * Tapback-row fields. Set iff this Message row is itself a tapback
   * against another message (i.e. a synthetic associated row), in which
   * case `reaction_target_guid` points at the message being reacted to.
   * Plain user messages leave all three absent.
   */
  reactionTargetGuid?: string | undefined;
  reactionTargetPartIndex?: number | undefined;
  reaction?:
    | MessageReaction
    | undefined;
  /** `true` = reaction added; `false` = reaction removed. */
  reactionSelected?:
    | boolean
    | undefined;
  /** Aggregated current state from associated rows that target this message. */
  appliedReactions: MessageAppliedReaction[];
  placedStickers: MessagePlacedSticker[];
  chatGuids: string[];
}

/**
 * Inline media payload returned by `MessageService.GetEmbeddedMedia`;
 * e.g. a sticker bundle or a balloon-app preview image.
 */
export interface EmbeddedMedia {
  data: Uint8Array;
  mimeType: string;
}

/** A new message has landed in a chat. */
export interface MessageReceived {
  message: Message | undefined;
}

/** An existing message was edited. */
export interface MessageEdited {
  messageGuid: string;
  content: MessageContent | undefined;
  editedAt: Date | undefined;
}

/** A message originally sent by the local user was read. */
export interface MessageRead {
  messageGuid: string;
  readAt: Date | undefined;
}

/** A message was retracted. */
export interface MessageUnsent {
  messageGuid: string;
  retractedAt: Date | undefined;
}

export interface MessageReactionAdded {
  messageGuid: string;
  targetPartIndex?: number | undefined;
  reaction: MessageReaction | undefined;
}

export interface MessageReactionRemoved {
  messageGuid: string;
  targetPartIndex?: number | undefined;
  reaction: MessageReaction | undefined;
}

export interface StickerPlaced {
  messageGuid: string;
  targetPartIndex?: number | undefined;
  sticker?: AttachmentInfo | undefined;
  placement?: StickerPlacement | undefined;
}

/** A discrete state transition observed for a message. */
export interface MessageChangeEvent {
  chatGuid: string;
  occurredAt: Date | undefined;
  actor?: SingleServiceAddressInfo | undefined;
  isFromMe: boolean;
  messageReceived?: MessageReceived | undefined;
  messageEdited?: MessageEdited | undefined;
  messageRead?: MessageRead | undefined;
  messageUnsent?: MessageUnsent | undefined;
  reactionAdded?: MessageReactionAdded | undefined;
  reactionRemoved?: MessageReactionRemoved | undefined;
  stickerPlaced?: StickerPlaced | undefined;
}

function createBaseMessageReaction(): MessageReaction {
  return { kind: 0, emoji: undefined };
}

export const MessageReaction: MessageFns<MessageReaction> = {
  encode(message: MessageReaction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    if (message.emoji !== undefined) {
      writer.uint32(18).string(message.emoji);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessageReaction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessageReaction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.emoji = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessageReaction {
    return {
      kind: isSet(object.kind) ? messageReactionKindFromJSON(object.kind) : 0,
      emoji: isSet(object.emoji) ? globalThis.String(object.emoji) : undefined,
    };
  },

  toJSON(message: MessageReaction): unknown {
    const obj: any = {};
    if (message.kind !== 0) {
      obj.kind = messageReactionKindToJSON(message.kind);
    }
    if (message.emoji !== undefined) {
      obj.emoji = message.emoji;
    }
    return obj;
  },

  create(base?: DeepPartial<MessageReaction>): MessageReaction {
    return MessageReaction.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MessageReaction>): MessageReaction {
    const message = createBaseMessageReaction();
    message.kind = object.kind ?? 0;
    message.emoji = object.emoji ?? undefined;
    return message;
  },
};

function createBaseMessageMention(): MessageMention {
  return { address: "", start: 0, length: 0 };
}

export const MessageMention: MessageFns<MessageMention> = {
  encode(message: MessageMention, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }
    if (message.start !== 0) {
      writer.uint32(16).int32(message.start);
    }
    if (message.length !== 0) {
      writer.uint32(24).int32(message.length);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessageMention {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessageMention();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.address = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.start = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.length = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessageMention {
    return {
      address: isSet(object.address) ? globalThis.String(object.address) : "",
      start: isSet(object.start) ? globalThis.Number(object.start) : 0,
      length: isSet(object.length) ? globalThis.Number(object.length) : 0,
    };
  },

  toJSON(message: MessageMention): unknown {
    const obj: any = {};
    if (message.address !== "") {
      obj.address = message.address;
    }
    if (message.start !== 0) {
      obj.start = Math.round(message.start);
    }
    if (message.length !== 0) {
      obj.length = Math.round(message.length);
    }
    return obj;
  },

  create(base?: DeepPartial<MessageMention>): MessageMention {
    return MessageMention.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MessageMention>): MessageMention {
    const message = createBaseMessageMention();
    message.address = object.address ?? "";
    message.start = object.start ?? 0;
    message.length = object.length ?? 0;
    return message;
  },
};

function createBaseTextFormat(): TextFormat {
  return { type: "", start: 0, length: 0, effectName: undefined };
}

export const TextFormat: MessageFns<TextFormat> = {
  encode(message: TextFormat, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== "") {
      writer.uint32(10).string(message.type);
    }
    if (message.start !== 0) {
      writer.uint32(16).int32(message.start);
    }
    if (message.length !== 0) {
      writer.uint32(24).int32(message.length);
    }
    if (message.effectName !== undefined) {
      writer.uint32(34).string(message.effectName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TextFormat {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTextFormat();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.start = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.length = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.effectName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TextFormat {
    return {
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      start: isSet(object.start) ? globalThis.Number(object.start) : 0,
      length: isSet(object.length) ? globalThis.Number(object.length) : 0,
      effectName: isSet(object.effectName)
        ? globalThis.String(object.effectName)
        : isSet(object.effect_name)
        ? globalThis.String(object.effect_name)
        : undefined,
    };
  },

  toJSON(message: TextFormat): unknown {
    const obj: any = {};
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.start !== 0) {
      obj.start = Math.round(message.start);
    }
    if (message.length !== 0) {
      obj.length = Math.round(message.length);
    }
    if (message.effectName !== undefined) {
      obj.effectName = message.effectName;
    }
    return obj;
  },

  create(base?: DeepPartial<TextFormat>): TextFormat {
    return TextFormat.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TextFormat>): TextFormat {
    const message = createBaseTextFormat();
    message.type = object.type ?? "";
    message.start = object.start ?? 0;
    message.length = object.length ?? 0;
    message.effectName = object.effectName ?? undefined;
    return message;
  },
};

function createBaseAttachmentRef(): AttachmentRef {
  return { attachmentPath: undefined, attachmentGuid: undefined, attachmentName: undefined };
}

export const AttachmentRef: MessageFns<AttachmentRef> = {
  encode(message: AttachmentRef, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.attachmentPath !== undefined) {
      writer.uint32(10).string(message.attachmentPath);
    }
    if (message.attachmentGuid !== undefined) {
      writer.uint32(18).string(message.attachmentGuid);
    }
    if (message.attachmentName !== undefined) {
      writer.uint32(26).string(message.attachmentName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttachmentRef {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttachmentRef();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attachmentPath = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.attachmentGuid = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.attachmentName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttachmentRef {
    return {
      attachmentPath: isSet(object.attachmentPath)
        ? globalThis.String(object.attachmentPath)
        : isSet(object.attachment_path)
        ? globalThis.String(object.attachment_path)
        : undefined,
      attachmentGuid: isSet(object.attachmentGuid)
        ? globalThis.String(object.attachmentGuid)
        : isSet(object.attachment_guid)
        ? globalThis.String(object.attachment_guid)
        : undefined,
      attachmentName: isSet(object.attachmentName)
        ? globalThis.String(object.attachmentName)
        : isSet(object.attachment_name)
        ? globalThis.String(object.attachment_name)
        : undefined,
    };
  },

  toJSON(message: AttachmentRef): unknown {
    const obj: any = {};
    if (message.attachmentPath !== undefined) {
      obj.attachmentPath = message.attachmentPath;
    }
    if (message.attachmentGuid !== undefined) {
      obj.attachmentGuid = message.attachmentGuid;
    }
    if (message.attachmentName !== undefined) {
      obj.attachmentName = message.attachmentName;
    }
    return obj;
  },

  create(base?: DeepPartial<AttachmentRef>): AttachmentRef {
    return AttachmentRef.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttachmentRef>): AttachmentRef {
    const message = createBaseAttachmentRef();
    message.attachmentPath = object.attachmentPath ?? undefined;
    message.attachmentGuid = object.attachmentGuid ?? undefined;
    message.attachmentName = object.attachmentName ?? undefined;
    return message;
  },
};

function createBaseReplyTarget(): ReplyTarget {
  return { messageGuid: "", targetPartIndex: undefined };
}

export const ReplyTarget: MessageFns<ReplyTarget> = {
  encode(message: ReplyTarget, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.messageGuid !== "") {
      writer.uint32(10).string(message.messageGuid);
    }
    if (message.targetPartIndex !== undefined) {
      writer.uint32(16).int32(message.targetPartIndex);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReplyTarget {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReplyTarget();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.messageGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.targetPartIndex = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReplyTarget {
    return {
      messageGuid: isSet(object.messageGuid)
        ? globalThis.String(object.messageGuid)
        : isSet(object.message_guid)
        ? globalThis.String(object.message_guid)
        : "",
      targetPartIndex: isSet(object.targetPartIndex)
        ? globalThis.Number(object.targetPartIndex)
        : isSet(object.target_part_index)
        ? globalThis.Number(object.target_part_index)
        : undefined,
    };
  },

  toJSON(message: ReplyTarget): unknown {
    const obj: any = {};
    if (message.messageGuid !== "") {
      obj.messageGuid = message.messageGuid;
    }
    if (message.targetPartIndex !== undefined) {
      obj.targetPartIndex = Math.round(message.targetPartIndex);
    }
    return obj;
  },

  create(base?: DeepPartial<ReplyTarget>): ReplyTarget {
    return ReplyTarget.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ReplyTarget>): ReplyTarget {
    const message = createBaseReplyTarget();
    message.messageGuid = object.messageGuid ?? "";
    message.targetPartIndex = object.targetPartIndex ?? undefined;
    return message;
  },
};

function createBaseStickerPlacement(): StickerPlacement {
  return { x: 0, y: 0, scale: undefined, rotation: undefined, width: undefined };
}

export const StickerPlacement: MessageFns<StickerPlacement> = {
  encode(message: StickerPlacement, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(9).double(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(17).double(message.y);
    }
    if (message.scale !== undefined) {
      writer.uint32(25).double(message.scale);
    }
    if (message.rotation !== undefined) {
      writer.uint32(33).double(message.rotation);
    }
    if (message.width !== undefined) {
      writer.uint32(41).double(message.width);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StickerPlacement {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStickerPlacement();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.x = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.y = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.scale = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.rotation = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.width = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StickerPlacement {
    return {
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      scale: isSet(object.scale) ? globalThis.Number(object.scale) : undefined,
      rotation: isSet(object.rotation) ? globalThis.Number(object.rotation) : undefined,
      width: isSet(object.width) ? globalThis.Number(object.width) : undefined,
    };
  },

  toJSON(message: StickerPlacement): unknown {
    const obj: any = {};
    if (message.x !== 0) {
      obj.x = message.x;
    }
    if (message.y !== 0) {
      obj.y = message.y;
    }
    if (message.scale !== undefined) {
      obj.scale = message.scale;
    }
    if (message.rotation !== undefined) {
      obj.rotation = message.rotation;
    }
    if (message.width !== undefined) {
      obj.width = message.width;
    }
    return obj;
  },

  create(base?: DeepPartial<StickerPlacement>): StickerPlacement {
    return StickerPlacement.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StickerPlacement>): StickerPlacement {
    const message = createBaseStickerPlacement();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    message.scale = object.scale ?? undefined;
    message.rotation = object.rotation ?? undefined;
    message.width = object.width ?? undefined;
    return message;
  },
};

function createBaseMessagePart(): MessagePart {
  return {
    text: undefined,
    attachment: undefined,
    mentionedAddress: undefined,
    bubbleIndex: undefined,
    formatting: [],
  };
}

export const MessagePart: MessageFns<MessagePart> = {
  encode(message: MessagePart, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.text !== undefined) {
      writer.uint32(10).string(message.text);
    }
    if (message.attachment !== undefined) {
      AttachmentRef.encode(message.attachment, writer.uint32(18).fork()).join();
    }
    if (message.mentionedAddress !== undefined) {
      writer.uint32(26).string(message.mentionedAddress);
    }
    if (message.bubbleIndex !== undefined) {
      writer.uint32(32).int32(message.bubbleIndex);
    }
    for (const v of message.formatting) {
      TextFormat.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessagePart {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessagePart();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.attachment = AttachmentRef.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.mentionedAddress = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.bubbleIndex = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.formatting.push(TextFormat.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessagePart {
    return {
      text: isSet(object.text) ? globalThis.String(object.text) : undefined,
      attachment: isSet(object.attachment) ? AttachmentRef.fromJSON(object.attachment) : undefined,
      mentionedAddress: isSet(object.mentionedAddress)
        ? globalThis.String(object.mentionedAddress)
        : isSet(object.mentioned_address)
        ? globalThis.String(object.mentioned_address)
        : undefined,
      bubbleIndex: isSet(object.bubbleIndex)
        ? globalThis.Number(object.bubbleIndex)
        : isSet(object.bubble_index)
        ? globalThis.Number(object.bubble_index)
        : undefined,
      formatting: globalThis.Array.isArray(object?.formatting)
        ? object.formatting.map((e: any) => TextFormat.fromJSON(e))
        : [],
    };
  },

  toJSON(message: MessagePart): unknown {
    const obj: any = {};
    if (message.text !== undefined) {
      obj.text = message.text;
    }
    if (message.attachment !== undefined) {
      obj.attachment = AttachmentRef.toJSON(message.attachment);
    }
    if (message.mentionedAddress !== undefined) {
      obj.mentionedAddress = message.mentionedAddress;
    }
    if (message.bubbleIndex !== undefined) {
      obj.bubbleIndex = Math.round(message.bubbleIndex);
    }
    if (message.formatting?.length) {
      obj.formatting = message.formatting.map((e) => TextFormat.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<MessagePart>): MessagePart {
    return MessagePart.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MessagePart>): MessagePart {
    const message = createBaseMessagePart();
    message.text = object.text ?? undefined;
    message.attachment = (object.attachment !== undefined && object.attachment !== null)
      ? AttachmentRef.fromPartial(object.attachment)
      : undefined;
    message.mentionedAddress = object.mentionedAddress ?? undefined;
    message.bubbleIndex = object.bubbleIndex ?? undefined;
    message.formatting = object.formatting?.map((e) => TextFormat.fromPartial(e)) || [];
    return message;
  },
};

function createBaseMessageContent(): MessageContent {
  return {
    text: undefined,
    attachments: [],
    formatting: [],
    mentions: [],
    balloonBundleId: undefined,
    expressiveSendStyleId: undefined,
  };
}

export const MessageContent: MessageFns<MessageContent> = {
  encode(message: MessageContent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.text !== undefined) {
      writer.uint32(10).string(message.text);
    }
    for (const v of message.attachments) {
      AttachmentInfo.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.formatting) {
      TextFormat.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.mentions) {
      MessageMention.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.balloonBundleId !== undefined) {
      writer.uint32(42).string(message.balloonBundleId);
    }
    if (message.expressiveSendStyleId !== undefined) {
      writer.uint32(50).string(message.expressiveSendStyleId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessageContent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessageContent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.attachments.push(AttachmentInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.formatting.push(TextFormat.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.mentions.push(MessageMention.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.balloonBundleId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.expressiveSendStyleId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessageContent {
    return {
      text: isSet(object.text) ? globalThis.String(object.text) : undefined,
      attachments: globalThis.Array.isArray(object?.attachments)
        ? object.attachments.map((e: any) => AttachmentInfo.fromJSON(e))
        : [],
      formatting: globalThis.Array.isArray(object?.formatting)
        ? object.formatting.map((e: any) => TextFormat.fromJSON(e))
        : [],
      mentions: globalThis.Array.isArray(object?.mentions)
        ? object.mentions.map((e: any) => MessageMention.fromJSON(e))
        : [],
      balloonBundleId: isSet(object.balloonBundleId)
        ? globalThis.String(object.balloonBundleId)
        : isSet(object.balloon_bundle_id)
        ? globalThis.String(object.balloon_bundle_id)
        : undefined,
      expressiveSendStyleId: isSet(object.expressiveSendStyleId)
        ? globalThis.String(object.expressiveSendStyleId)
        : isSet(object.expressive_send_style_id)
        ? globalThis.String(object.expressive_send_style_id)
        : undefined,
    };
  },

  toJSON(message: MessageContent): unknown {
    const obj: any = {};
    if (message.text !== undefined) {
      obj.text = message.text;
    }
    if (message.attachments?.length) {
      obj.attachments = message.attachments.map((e) => AttachmentInfo.toJSON(e));
    }
    if (message.formatting?.length) {
      obj.formatting = message.formatting.map((e) => TextFormat.toJSON(e));
    }
    if (message.mentions?.length) {
      obj.mentions = message.mentions.map((e) => MessageMention.toJSON(e));
    }
    if (message.balloonBundleId !== undefined) {
      obj.balloonBundleId = message.balloonBundleId;
    }
    if (message.expressiveSendStyleId !== undefined) {
      obj.expressiveSendStyleId = message.expressiveSendStyleId;
    }
    return obj;
  },

  create(base?: DeepPartial<MessageContent>): MessageContent {
    return MessageContent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MessageContent>): MessageContent {
    const message = createBaseMessageContent();
    message.text = object.text ?? undefined;
    message.attachments = object.attachments?.map((e) => AttachmentInfo.fromPartial(e)) || [];
    message.formatting = object.formatting?.map((e) => TextFormat.fromPartial(e)) || [];
    message.mentions = object.mentions?.map((e) => MessageMention.fromPartial(e)) || [];
    message.balloonBundleId = object.balloonBundleId ?? undefined;
    message.expressiveSendStyleId = object.expressiveSendStyleId ?? undefined;
    return message;
  },
};

function createBaseMessageAppliedReaction(): MessageAppliedReaction {
  return {
    messageGuid: "",
    targetPartIndex: undefined,
    reaction: undefined,
    sender: undefined,
    isFromMe: false,
    dateCreated: undefined,
  };
}

export const MessageAppliedReaction: MessageFns<MessageAppliedReaction> = {
  encode(message: MessageAppliedReaction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.messageGuid !== "") {
      writer.uint32(10).string(message.messageGuid);
    }
    if (message.targetPartIndex !== undefined) {
      writer.uint32(16).int32(message.targetPartIndex);
    }
    if (message.reaction !== undefined) {
      MessageReaction.encode(message.reaction, writer.uint32(26).fork()).join();
    }
    if (message.sender !== undefined) {
      SingleServiceAddressInfo.encode(message.sender, writer.uint32(34).fork()).join();
    }
    if (message.isFromMe !== false) {
      writer.uint32(40).bool(message.isFromMe);
    }
    if (message.dateCreated !== undefined) {
      Timestamp.encode(toTimestamp(message.dateCreated), writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessageAppliedReaction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessageAppliedReaction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.messageGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.targetPartIndex = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.reaction = MessageReaction.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.sender = SingleServiceAddressInfo.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.isFromMe = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.dateCreated = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessageAppliedReaction {
    return {
      messageGuid: isSet(object.messageGuid)
        ? globalThis.String(object.messageGuid)
        : isSet(object.message_guid)
        ? globalThis.String(object.message_guid)
        : "",
      targetPartIndex: isSet(object.targetPartIndex)
        ? globalThis.Number(object.targetPartIndex)
        : isSet(object.target_part_index)
        ? globalThis.Number(object.target_part_index)
        : undefined,
      reaction: isSet(object.reaction) ? MessageReaction.fromJSON(object.reaction) : undefined,
      sender: isSet(object.sender) ? SingleServiceAddressInfo.fromJSON(object.sender) : undefined,
      isFromMe: isSet(object.isFromMe)
        ? globalThis.Boolean(object.isFromMe)
        : isSet(object.is_from_me)
        ? globalThis.Boolean(object.is_from_me)
        : false,
      dateCreated: isSet(object.dateCreated)
        ? fromJsonTimestamp(object.dateCreated)
        : isSet(object.date_created)
        ? fromJsonTimestamp(object.date_created)
        : undefined,
    };
  },

  toJSON(message: MessageAppliedReaction): unknown {
    const obj: any = {};
    if (message.messageGuid !== "") {
      obj.messageGuid = message.messageGuid;
    }
    if (message.targetPartIndex !== undefined) {
      obj.targetPartIndex = Math.round(message.targetPartIndex);
    }
    if (message.reaction !== undefined) {
      obj.reaction = MessageReaction.toJSON(message.reaction);
    }
    if (message.sender !== undefined) {
      obj.sender = SingleServiceAddressInfo.toJSON(message.sender);
    }
    if (message.isFromMe !== false) {
      obj.isFromMe = message.isFromMe;
    }
    if (message.dateCreated !== undefined) {
      obj.dateCreated = message.dateCreated.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<MessageAppliedReaction>): MessageAppliedReaction {
    return MessageAppliedReaction.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MessageAppliedReaction>): MessageAppliedReaction {
    const message = createBaseMessageAppliedReaction();
    message.messageGuid = object.messageGuid ?? "";
    message.targetPartIndex = object.targetPartIndex ?? undefined;
    message.reaction = (object.reaction !== undefined && object.reaction !== null)
      ? MessageReaction.fromPartial(object.reaction)
      : undefined;
    message.sender = (object.sender !== undefined && object.sender !== null)
      ? SingleServiceAddressInfo.fromPartial(object.sender)
      : undefined;
    message.isFromMe = object.isFromMe ?? false;
    message.dateCreated = object.dateCreated ?? undefined;
    return message;
  },
};

function createBaseMessagePlacedSticker(): MessagePlacedSticker {
  return {
    messageGuid: "",
    targetPartIndex: undefined,
    sender: undefined,
    isFromMe: false,
    dateCreated: undefined,
    sticker: undefined,
    placement: undefined,
  };
}

export const MessagePlacedSticker: MessageFns<MessagePlacedSticker> = {
  encode(message: MessagePlacedSticker, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.messageGuid !== "") {
      writer.uint32(10).string(message.messageGuid);
    }
    if (message.targetPartIndex !== undefined) {
      writer.uint32(16).int32(message.targetPartIndex);
    }
    if (message.sender !== undefined) {
      SingleServiceAddressInfo.encode(message.sender, writer.uint32(26).fork()).join();
    }
    if (message.isFromMe !== false) {
      writer.uint32(32).bool(message.isFromMe);
    }
    if (message.dateCreated !== undefined) {
      Timestamp.encode(toTimestamp(message.dateCreated), writer.uint32(42).fork()).join();
    }
    if (message.sticker !== undefined) {
      AttachmentInfo.encode(message.sticker, writer.uint32(50).fork()).join();
    }
    if (message.placement !== undefined) {
      StickerPlacement.encode(message.placement, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessagePlacedSticker {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessagePlacedSticker();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.messageGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.targetPartIndex = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sender = SingleServiceAddressInfo.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isFromMe = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.dateCreated = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.sticker = AttachmentInfo.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.placement = StickerPlacement.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessagePlacedSticker {
    return {
      messageGuid: isSet(object.messageGuid)
        ? globalThis.String(object.messageGuid)
        : isSet(object.message_guid)
        ? globalThis.String(object.message_guid)
        : "",
      targetPartIndex: isSet(object.targetPartIndex)
        ? globalThis.Number(object.targetPartIndex)
        : isSet(object.target_part_index)
        ? globalThis.Number(object.target_part_index)
        : undefined,
      sender: isSet(object.sender) ? SingleServiceAddressInfo.fromJSON(object.sender) : undefined,
      isFromMe: isSet(object.isFromMe)
        ? globalThis.Boolean(object.isFromMe)
        : isSet(object.is_from_me)
        ? globalThis.Boolean(object.is_from_me)
        : false,
      dateCreated: isSet(object.dateCreated)
        ? fromJsonTimestamp(object.dateCreated)
        : isSet(object.date_created)
        ? fromJsonTimestamp(object.date_created)
        : undefined,
      sticker: isSet(object.sticker) ? AttachmentInfo.fromJSON(object.sticker) : undefined,
      placement: isSet(object.placement) ? StickerPlacement.fromJSON(object.placement) : undefined,
    };
  },

  toJSON(message: MessagePlacedSticker): unknown {
    const obj: any = {};
    if (message.messageGuid !== "") {
      obj.messageGuid = message.messageGuid;
    }
    if (message.targetPartIndex !== undefined) {
      obj.targetPartIndex = Math.round(message.targetPartIndex);
    }
    if (message.sender !== undefined) {
      obj.sender = SingleServiceAddressInfo.toJSON(message.sender);
    }
    if (message.isFromMe !== false) {
      obj.isFromMe = message.isFromMe;
    }
    if (message.dateCreated !== undefined) {
      obj.dateCreated = message.dateCreated.toISOString();
    }
    if (message.sticker !== undefined) {
      obj.sticker = AttachmentInfo.toJSON(message.sticker);
    }
    if (message.placement !== undefined) {
      obj.placement = StickerPlacement.toJSON(message.placement);
    }
    return obj;
  },

  create(base?: DeepPartial<MessagePlacedSticker>): MessagePlacedSticker {
    return MessagePlacedSticker.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MessagePlacedSticker>): MessagePlacedSticker {
    const message = createBaseMessagePlacedSticker();
    message.messageGuid = object.messageGuid ?? "";
    message.targetPartIndex = object.targetPartIndex ?? undefined;
    message.sender = (object.sender !== undefined && object.sender !== null)
      ? SingleServiceAddressInfo.fromPartial(object.sender)
      : undefined;
    message.isFromMe = object.isFromMe ?? false;
    message.dateCreated = object.dateCreated ?? undefined;
    message.sticker = (object.sticker !== undefined && object.sticker !== null)
      ? AttachmentInfo.fromPartial(object.sticker)
      : undefined;
    message.placement = (object.placement !== undefined && object.placement !== null)
      ? StickerPlacement.fromPartial(object.placement)
      : undefined;
    return message;
  },
};

function createBaseMessage(): Message {
  return {
    guid: "",
    content: undefined,
    subject: undefined,
    dateCreated: undefined,
    dateRead: undefined,
    dateDelivered: undefined,
    dateEdited: undefined,
    dateRetracted: undefined,
    datePlayed: undefined,
    dateExpressiveSendPlayed: undefined,
    sender: undefined,
    isFromMe: false,
    isSent: false,
    isDelivered: false,
    isDeliveredQuietly: false,
    didNotifyRecipient: false,
    sendErrorCode: 0,
    isAudioMessage: false,
    isAutoReply: false,
    isSystemMessage: false,
    isForward: false,
    isDelayed: false,
    isSpam: false,
    dataDetectorResultsPresent: false,
    isArchived: false,
    isServiceMessage: false,
    isCorrupt: false,
    isExpirable: false,
    shareStatus: undefined,
    shareDirection: undefined,
    itemType: 0,
    groupTitle: undefined,
    chatActionType: undefined,
    threadOriginatorGuid: undefined,
    threadOriginatorPart: undefined,
    replyToGuid: undefined,
    replyTargetGuid: undefined,
    destinationCallerId: undefined,
    partCount: undefined,
    cachedRoomNames: undefined,
    reactionTargetGuid: undefined,
    reactionTargetPartIndex: undefined,
    reaction: undefined,
    reactionSelected: undefined,
    appliedReactions: [],
    placedStickers: [],
    chatGuids: [],
  };
}

export const Message: MessageFns<Message> = {
  encode(message: Message, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.guid !== "") {
      writer.uint32(10).string(message.guid);
    }
    if (message.content !== undefined) {
      MessageContent.encode(message.content, writer.uint32(18).fork()).join();
    }
    if (message.subject !== undefined) {
      writer.uint32(26).string(message.subject);
    }
    if (message.dateCreated !== undefined) {
      Timestamp.encode(toTimestamp(message.dateCreated), writer.uint32(82).fork()).join();
    }
    if (message.dateRead !== undefined) {
      Timestamp.encode(toTimestamp(message.dateRead), writer.uint32(90).fork()).join();
    }
    if (message.dateDelivered !== undefined) {
      Timestamp.encode(toTimestamp(message.dateDelivered), writer.uint32(98).fork()).join();
    }
    if (message.dateEdited !== undefined) {
      Timestamp.encode(toTimestamp(message.dateEdited), writer.uint32(106).fork()).join();
    }
    if (message.dateRetracted !== undefined) {
      Timestamp.encode(toTimestamp(message.dateRetracted), writer.uint32(114).fork()).join();
    }
    if (message.datePlayed !== undefined) {
      Timestamp.encode(toTimestamp(message.datePlayed), writer.uint32(122).fork()).join();
    }
    if (message.dateExpressiveSendPlayed !== undefined) {
      Timestamp.encode(toTimestamp(message.dateExpressiveSendPlayed), writer.uint32(130).fork()).join();
    }
    if (message.sender !== undefined) {
      SingleServiceAddressInfo.encode(message.sender, writer.uint32(162).fork()).join();
    }
    if (message.isFromMe !== false) {
      writer.uint32(168).bool(message.isFromMe);
    }
    if (message.isSent !== false) {
      writer.uint32(240).bool(message.isSent);
    }
    if (message.isDelivered !== false) {
      writer.uint32(248).bool(message.isDelivered);
    }
    if (message.isDeliveredQuietly !== false) {
      writer.uint32(256).bool(message.isDeliveredQuietly);
    }
    if (message.didNotifyRecipient !== false) {
      writer.uint32(264).bool(message.didNotifyRecipient);
    }
    if (message.sendErrorCode !== 0) {
      writer.uint32(272).int32(message.sendErrorCode);
    }
    if (message.isAudioMessage !== false) {
      writer.uint32(320).bool(message.isAudioMessage);
    }
    if (message.isAutoReply !== false) {
      writer.uint32(328).bool(message.isAutoReply);
    }
    if (message.isSystemMessage !== false) {
      writer.uint32(336).bool(message.isSystemMessage);
    }
    if (message.isForward !== false) {
      writer.uint32(344).bool(message.isForward);
    }
    if (message.isDelayed !== false) {
      writer.uint32(352).bool(message.isDelayed);
    }
    if (message.isSpam !== false) {
      writer.uint32(360).bool(message.isSpam);
    }
    if (message.dataDetectorResultsPresent !== false) {
      writer.uint32(368).bool(message.dataDetectorResultsPresent);
    }
    if (message.isArchived !== false) {
      writer.uint32(376).bool(message.isArchived);
    }
    if (message.isServiceMessage !== false) {
      writer.uint32(384).bool(message.isServiceMessage);
    }
    if (message.isCorrupt !== false) {
      writer.uint32(392).bool(message.isCorrupt);
    }
    if (message.isExpirable !== false) {
      writer.uint32(400).bool(message.isExpirable);
    }
    if (message.shareStatus !== undefined) {
      writer.uint32(408).int32(message.shareStatus);
    }
    if (message.shareDirection !== undefined) {
      writer.uint32(416).int32(message.shareDirection);
    }
    if (message.itemType !== 0) {
      writer.uint32(480).int32(message.itemType);
    }
    if (message.groupTitle !== undefined) {
      writer.uint32(490).string(message.groupTitle);
    }
    if (message.chatActionType !== undefined) {
      writer.uint32(496).int32(message.chatActionType);
    }
    if (message.threadOriginatorGuid !== undefined) {
      writer.uint32(570).string(message.threadOriginatorGuid);
    }
    if (message.threadOriginatorPart !== undefined) {
      writer.uint32(578).string(message.threadOriginatorPart);
    }
    if (message.replyToGuid !== undefined) {
      writer.uint32(586).string(message.replyToGuid);
    }
    if (message.replyTargetGuid !== undefined) {
      writer.uint32(594).string(message.replyTargetGuid);
    }
    if (message.destinationCallerId !== undefined) {
      writer.uint32(602).string(message.destinationCallerId);
    }
    if (message.partCount !== undefined) {
      writer.uint32(608).int32(message.partCount);
    }
    if (message.cachedRoomNames !== undefined) {
      writer.uint32(618).string(message.cachedRoomNames);
    }
    if (message.reactionTargetGuid !== undefined) {
      writer.uint32(642).string(message.reactionTargetGuid);
    }
    if (message.reactionTargetPartIndex !== undefined) {
      writer.uint32(648).int32(message.reactionTargetPartIndex);
    }
    if (message.reaction !== undefined) {
      MessageReaction.encode(message.reaction, writer.uint32(658).fork()).join();
    }
    if (message.reactionSelected !== undefined) {
      writer.uint32(664).bool(message.reactionSelected);
    }
    for (const v of message.appliedReactions) {
      MessageAppliedReaction.encode(v!, writer.uint32(722).fork()).join();
    }
    for (const v of message.placedStickers) {
      MessagePlacedSticker.encode(v!, writer.uint32(730).fork()).join();
    }
    for (const v of message.chatGuids) {
      writer.uint32(738).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Message {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.guid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.content = MessageContent.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.subject = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.dateCreated = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.dateRead = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.dateDelivered = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.dateEdited = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.dateRetracted = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.datePlayed = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.dateExpressiveSendPlayed = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.sender = SingleServiceAddressInfo.decode(reader, reader.uint32());
          continue;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.isFromMe = reader.bool();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.isSent = reader.bool();
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.isDelivered = reader.bool();
          continue;
        }
        case 32: {
          if (tag !== 256) {
            break;
          }

          message.isDeliveredQuietly = reader.bool();
          continue;
        }
        case 33: {
          if (tag !== 264) {
            break;
          }

          message.didNotifyRecipient = reader.bool();
          continue;
        }
        case 34: {
          if (tag !== 272) {
            break;
          }

          message.sendErrorCode = reader.int32();
          continue;
        }
        case 40: {
          if (tag !== 320) {
            break;
          }

          message.isAudioMessage = reader.bool();
          continue;
        }
        case 41: {
          if (tag !== 328) {
            break;
          }

          message.isAutoReply = reader.bool();
          continue;
        }
        case 42: {
          if (tag !== 336) {
            break;
          }

          message.isSystemMessage = reader.bool();
          continue;
        }
        case 43: {
          if (tag !== 344) {
            break;
          }

          message.isForward = reader.bool();
          continue;
        }
        case 44: {
          if (tag !== 352) {
            break;
          }

          message.isDelayed = reader.bool();
          continue;
        }
        case 45: {
          if (tag !== 360) {
            break;
          }

          message.isSpam = reader.bool();
          continue;
        }
        case 46: {
          if (tag !== 368) {
            break;
          }

          message.dataDetectorResultsPresent = reader.bool();
          continue;
        }
        case 47: {
          if (tag !== 376) {
            break;
          }

          message.isArchived = reader.bool();
          continue;
        }
        case 48: {
          if (tag !== 384) {
            break;
          }

          message.isServiceMessage = reader.bool();
          continue;
        }
        case 49: {
          if (tag !== 392) {
            break;
          }

          message.isCorrupt = reader.bool();
          continue;
        }
        case 50: {
          if (tag !== 400) {
            break;
          }

          message.isExpirable = reader.bool();
          continue;
        }
        case 51: {
          if (tag !== 408) {
            break;
          }

          message.shareStatus = reader.int32();
          continue;
        }
        case 52: {
          if (tag !== 416) {
            break;
          }

          message.shareDirection = reader.int32();
          continue;
        }
        case 60: {
          if (tag !== 480) {
            break;
          }

          message.itemType = reader.int32() as any;
          continue;
        }
        case 61: {
          if (tag !== 490) {
            break;
          }

          message.groupTitle = reader.string();
          continue;
        }
        case 62: {
          if (tag !== 496) {
            break;
          }

          message.chatActionType = reader.int32();
          continue;
        }
        case 71: {
          if (tag !== 570) {
            break;
          }

          message.threadOriginatorGuid = reader.string();
          continue;
        }
        case 72: {
          if (tag !== 578) {
            break;
          }

          message.threadOriginatorPart = reader.string();
          continue;
        }
        case 73: {
          if (tag !== 586) {
            break;
          }

          message.replyToGuid = reader.string();
          continue;
        }
        case 74: {
          if (tag !== 594) {
            break;
          }

          message.replyTargetGuid = reader.string();
          continue;
        }
        case 75: {
          if (tag !== 602) {
            break;
          }

          message.destinationCallerId = reader.string();
          continue;
        }
        case 76: {
          if (tag !== 608) {
            break;
          }

          message.partCount = reader.int32();
          continue;
        }
        case 77: {
          if (tag !== 618) {
            break;
          }

          message.cachedRoomNames = reader.string();
          continue;
        }
        case 80: {
          if (tag !== 642) {
            break;
          }

          message.reactionTargetGuid = reader.string();
          continue;
        }
        case 81: {
          if (tag !== 648) {
            break;
          }

          message.reactionTargetPartIndex = reader.int32();
          continue;
        }
        case 82: {
          if (tag !== 658) {
            break;
          }

          message.reaction = MessageReaction.decode(reader, reader.uint32());
          continue;
        }
        case 83: {
          if (tag !== 664) {
            break;
          }

          message.reactionSelected = reader.bool();
          continue;
        }
        case 90: {
          if (tag !== 722) {
            break;
          }

          message.appliedReactions.push(MessageAppliedReaction.decode(reader, reader.uint32()));
          continue;
        }
        case 91: {
          if (tag !== 730) {
            break;
          }

          message.placedStickers.push(MessagePlacedSticker.decode(reader, reader.uint32()));
          continue;
        }
        case 92: {
          if (tag !== 738) {
            break;
          }

          message.chatGuids.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Message {
    return {
      guid: isSet(object.guid) ? globalThis.String(object.guid) : "",
      content: isSet(object.content) ? MessageContent.fromJSON(object.content) : undefined,
      subject: isSet(object.subject) ? globalThis.String(object.subject) : undefined,
      dateCreated: isSet(object.dateCreated)
        ? fromJsonTimestamp(object.dateCreated)
        : isSet(object.date_created)
        ? fromJsonTimestamp(object.date_created)
        : undefined,
      dateRead: isSet(object.dateRead)
        ? fromJsonTimestamp(object.dateRead)
        : isSet(object.date_read)
        ? fromJsonTimestamp(object.date_read)
        : undefined,
      dateDelivered: isSet(object.dateDelivered)
        ? fromJsonTimestamp(object.dateDelivered)
        : isSet(object.date_delivered)
        ? fromJsonTimestamp(object.date_delivered)
        : undefined,
      dateEdited: isSet(object.dateEdited)
        ? fromJsonTimestamp(object.dateEdited)
        : isSet(object.date_edited)
        ? fromJsonTimestamp(object.date_edited)
        : undefined,
      dateRetracted: isSet(object.dateRetracted)
        ? fromJsonTimestamp(object.dateRetracted)
        : isSet(object.date_retracted)
        ? fromJsonTimestamp(object.date_retracted)
        : undefined,
      datePlayed: isSet(object.datePlayed)
        ? fromJsonTimestamp(object.datePlayed)
        : isSet(object.date_played)
        ? fromJsonTimestamp(object.date_played)
        : undefined,
      dateExpressiveSendPlayed: isSet(object.dateExpressiveSendPlayed)
        ? fromJsonTimestamp(object.dateExpressiveSendPlayed)
        : isSet(object.date_expressive_send_played)
        ? fromJsonTimestamp(object.date_expressive_send_played)
        : undefined,
      sender: isSet(object.sender) ? SingleServiceAddressInfo.fromJSON(object.sender) : undefined,
      isFromMe: isSet(object.isFromMe)
        ? globalThis.Boolean(object.isFromMe)
        : isSet(object.is_from_me)
        ? globalThis.Boolean(object.is_from_me)
        : false,
      isSent: isSet(object.isSent)
        ? globalThis.Boolean(object.isSent)
        : isSet(object.is_sent)
        ? globalThis.Boolean(object.is_sent)
        : false,
      isDelivered: isSet(object.isDelivered)
        ? globalThis.Boolean(object.isDelivered)
        : isSet(object.is_delivered)
        ? globalThis.Boolean(object.is_delivered)
        : false,
      isDeliveredQuietly: isSet(object.isDeliveredQuietly)
        ? globalThis.Boolean(object.isDeliveredQuietly)
        : isSet(object.is_delivered_quietly)
        ? globalThis.Boolean(object.is_delivered_quietly)
        : false,
      didNotifyRecipient: isSet(object.didNotifyRecipient)
        ? globalThis.Boolean(object.didNotifyRecipient)
        : isSet(object.did_notify_recipient)
        ? globalThis.Boolean(object.did_notify_recipient)
        : false,
      sendErrorCode: isSet(object.sendErrorCode)
        ? globalThis.Number(object.sendErrorCode)
        : isSet(object.send_error_code)
        ? globalThis.Number(object.send_error_code)
        : 0,
      isAudioMessage: isSet(object.isAudioMessage)
        ? globalThis.Boolean(object.isAudioMessage)
        : isSet(object.is_audio_message)
        ? globalThis.Boolean(object.is_audio_message)
        : false,
      isAutoReply: isSet(object.isAutoReply)
        ? globalThis.Boolean(object.isAutoReply)
        : isSet(object.is_auto_reply)
        ? globalThis.Boolean(object.is_auto_reply)
        : false,
      isSystemMessage: isSet(object.isSystemMessage)
        ? globalThis.Boolean(object.isSystemMessage)
        : isSet(object.is_system_message)
        ? globalThis.Boolean(object.is_system_message)
        : false,
      isForward: isSet(object.isForward)
        ? globalThis.Boolean(object.isForward)
        : isSet(object.is_forward)
        ? globalThis.Boolean(object.is_forward)
        : false,
      isDelayed: isSet(object.isDelayed)
        ? globalThis.Boolean(object.isDelayed)
        : isSet(object.is_delayed)
        ? globalThis.Boolean(object.is_delayed)
        : false,
      isSpam: isSet(object.isSpam)
        ? globalThis.Boolean(object.isSpam)
        : isSet(object.is_spam)
        ? globalThis.Boolean(object.is_spam)
        : false,
      dataDetectorResultsPresent: isSet(object.dataDetectorResultsPresent)
        ? globalThis.Boolean(object.dataDetectorResultsPresent)
        : isSet(object.data_detector_results_present)
        ? globalThis.Boolean(object.data_detector_results_present)
        : false,
      isArchived: isSet(object.isArchived)
        ? globalThis.Boolean(object.isArchived)
        : isSet(object.is_archived)
        ? globalThis.Boolean(object.is_archived)
        : false,
      isServiceMessage: isSet(object.isServiceMessage)
        ? globalThis.Boolean(object.isServiceMessage)
        : isSet(object.is_service_message)
        ? globalThis.Boolean(object.is_service_message)
        : false,
      isCorrupt: isSet(object.isCorrupt)
        ? globalThis.Boolean(object.isCorrupt)
        : isSet(object.is_corrupt)
        ? globalThis.Boolean(object.is_corrupt)
        : false,
      isExpirable: isSet(object.isExpirable)
        ? globalThis.Boolean(object.isExpirable)
        : isSet(object.is_expirable)
        ? globalThis.Boolean(object.is_expirable)
        : false,
      shareStatus: isSet(object.shareStatus)
        ? globalThis.Number(object.shareStatus)
        : isSet(object.share_status)
        ? globalThis.Number(object.share_status)
        : undefined,
      shareDirection: isSet(object.shareDirection)
        ? globalThis.Number(object.shareDirection)
        : isSet(object.share_direction)
        ? globalThis.Number(object.share_direction)
        : undefined,
      itemType: isSet(object.itemType)
        ? messageItemTypeFromJSON(object.itemType)
        : isSet(object.item_type)
        ? messageItemTypeFromJSON(object.item_type)
        : 0,
      groupTitle: isSet(object.groupTitle)
        ? globalThis.String(object.groupTitle)
        : isSet(object.group_title)
        ? globalThis.String(object.group_title)
        : undefined,
      chatActionType: isSet(object.chatActionType)
        ? globalThis.Number(object.chatActionType)
        : isSet(object.chat_action_type)
        ? globalThis.Number(object.chat_action_type)
        : undefined,
      threadOriginatorGuid: isSet(object.threadOriginatorGuid)
        ? globalThis.String(object.threadOriginatorGuid)
        : isSet(object.thread_originator_guid)
        ? globalThis.String(object.thread_originator_guid)
        : undefined,
      threadOriginatorPart: isSet(object.threadOriginatorPart)
        ? globalThis.String(object.threadOriginatorPart)
        : isSet(object.thread_originator_part)
        ? globalThis.String(object.thread_originator_part)
        : undefined,
      replyToGuid: isSet(object.replyToGuid)
        ? globalThis.String(object.replyToGuid)
        : isSet(object.reply_to_guid)
        ? globalThis.String(object.reply_to_guid)
        : undefined,
      replyTargetGuid: isSet(object.replyTargetGuid)
        ? globalThis.String(object.replyTargetGuid)
        : isSet(object.reply_target_guid)
        ? globalThis.String(object.reply_target_guid)
        : undefined,
      destinationCallerId: isSet(object.destinationCallerId)
        ? globalThis.String(object.destinationCallerId)
        : isSet(object.destination_caller_id)
        ? globalThis.String(object.destination_caller_id)
        : undefined,
      partCount: isSet(object.partCount)
        ? globalThis.Number(object.partCount)
        : isSet(object.part_count)
        ? globalThis.Number(object.part_count)
        : undefined,
      cachedRoomNames: isSet(object.cachedRoomNames)
        ? globalThis.String(object.cachedRoomNames)
        : isSet(object.cached_room_names)
        ? globalThis.String(object.cached_room_names)
        : undefined,
      reactionTargetGuid: isSet(object.reactionTargetGuid)
        ? globalThis.String(object.reactionTargetGuid)
        : isSet(object.reaction_target_guid)
        ? globalThis.String(object.reaction_target_guid)
        : undefined,
      reactionTargetPartIndex: isSet(object.reactionTargetPartIndex)
        ? globalThis.Number(object.reactionTargetPartIndex)
        : isSet(object.reaction_target_part_index)
        ? globalThis.Number(object.reaction_target_part_index)
        : undefined,
      reaction: isSet(object.reaction) ? MessageReaction.fromJSON(object.reaction) : undefined,
      reactionSelected: isSet(object.reactionSelected)
        ? globalThis.Boolean(object.reactionSelected)
        : isSet(object.reaction_selected)
        ? globalThis.Boolean(object.reaction_selected)
        : undefined,
      appliedReactions: globalThis.Array.isArray(object?.appliedReactions)
        ? object.appliedReactions.map((e: any) => MessageAppliedReaction.fromJSON(e))
        : globalThis.Array.isArray(object?.applied_reactions)
        ? object.applied_reactions.map((e: any) => MessageAppliedReaction.fromJSON(e))
        : [],
      placedStickers: globalThis.Array.isArray(object?.placedStickers)
        ? object.placedStickers.map((e: any) => MessagePlacedSticker.fromJSON(e))
        : globalThis.Array.isArray(object?.placed_stickers)
        ? object.placed_stickers.map((e: any) => MessagePlacedSticker.fromJSON(e))
        : [],
      chatGuids: globalThis.Array.isArray(object?.chatGuids)
        ? object.chatGuids.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.chat_guids)
        ? object.chat_guids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: Message): unknown {
    const obj: any = {};
    if (message.guid !== "") {
      obj.guid = message.guid;
    }
    if (message.content !== undefined) {
      obj.content = MessageContent.toJSON(message.content);
    }
    if (message.subject !== undefined) {
      obj.subject = message.subject;
    }
    if (message.dateCreated !== undefined) {
      obj.dateCreated = message.dateCreated.toISOString();
    }
    if (message.dateRead !== undefined) {
      obj.dateRead = message.dateRead.toISOString();
    }
    if (message.dateDelivered !== undefined) {
      obj.dateDelivered = message.dateDelivered.toISOString();
    }
    if (message.dateEdited !== undefined) {
      obj.dateEdited = message.dateEdited.toISOString();
    }
    if (message.dateRetracted !== undefined) {
      obj.dateRetracted = message.dateRetracted.toISOString();
    }
    if (message.datePlayed !== undefined) {
      obj.datePlayed = message.datePlayed.toISOString();
    }
    if (message.dateExpressiveSendPlayed !== undefined) {
      obj.dateExpressiveSendPlayed = message.dateExpressiveSendPlayed.toISOString();
    }
    if (message.sender !== undefined) {
      obj.sender = SingleServiceAddressInfo.toJSON(message.sender);
    }
    if (message.isFromMe !== false) {
      obj.isFromMe = message.isFromMe;
    }
    if (message.isSent !== false) {
      obj.isSent = message.isSent;
    }
    if (message.isDelivered !== false) {
      obj.isDelivered = message.isDelivered;
    }
    if (message.isDeliveredQuietly !== false) {
      obj.isDeliveredQuietly = message.isDeliveredQuietly;
    }
    if (message.didNotifyRecipient !== false) {
      obj.didNotifyRecipient = message.didNotifyRecipient;
    }
    if (message.sendErrorCode !== 0) {
      obj.sendErrorCode = Math.round(message.sendErrorCode);
    }
    if (message.isAudioMessage !== false) {
      obj.isAudioMessage = message.isAudioMessage;
    }
    if (message.isAutoReply !== false) {
      obj.isAutoReply = message.isAutoReply;
    }
    if (message.isSystemMessage !== false) {
      obj.isSystemMessage = message.isSystemMessage;
    }
    if (message.isForward !== false) {
      obj.isForward = message.isForward;
    }
    if (message.isDelayed !== false) {
      obj.isDelayed = message.isDelayed;
    }
    if (message.isSpam !== false) {
      obj.isSpam = message.isSpam;
    }
    if (message.dataDetectorResultsPresent !== false) {
      obj.dataDetectorResultsPresent = message.dataDetectorResultsPresent;
    }
    if (message.isArchived !== false) {
      obj.isArchived = message.isArchived;
    }
    if (message.isServiceMessage !== false) {
      obj.isServiceMessage = message.isServiceMessage;
    }
    if (message.isCorrupt !== false) {
      obj.isCorrupt = message.isCorrupt;
    }
    if (message.isExpirable !== false) {
      obj.isExpirable = message.isExpirable;
    }
    if (message.shareStatus !== undefined) {
      obj.shareStatus = Math.round(message.shareStatus);
    }
    if (message.shareDirection !== undefined) {
      obj.shareDirection = Math.round(message.shareDirection);
    }
    if (message.itemType !== 0) {
      obj.itemType = messageItemTypeToJSON(message.itemType);
    }
    if (message.groupTitle !== undefined) {
      obj.groupTitle = message.groupTitle;
    }
    if (message.chatActionType !== undefined) {
      obj.chatActionType = Math.round(message.chatActionType);
    }
    if (message.threadOriginatorGuid !== undefined) {
      obj.threadOriginatorGuid = message.threadOriginatorGuid;
    }
    if (message.threadOriginatorPart !== undefined) {
      obj.threadOriginatorPart = message.threadOriginatorPart;
    }
    if (message.replyToGuid !== undefined) {
      obj.replyToGuid = message.replyToGuid;
    }
    if (message.replyTargetGuid !== undefined) {
      obj.replyTargetGuid = message.replyTargetGuid;
    }
    if (message.destinationCallerId !== undefined) {
      obj.destinationCallerId = message.destinationCallerId;
    }
    if (message.partCount !== undefined) {
      obj.partCount = Math.round(message.partCount);
    }
    if (message.cachedRoomNames !== undefined) {
      obj.cachedRoomNames = message.cachedRoomNames;
    }
    if (message.reactionTargetGuid !== undefined) {
      obj.reactionTargetGuid = message.reactionTargetGuid;
    }
    if (message.reactionTargetPartIndex !== undefined) {
      obj.reactionTargetPartIndex = Math.round(message.reactionTargetPartIndex);
    }
    if (message.reaction !== undefined) {
      obj.reaction = MessageReaction.toJSON(message.reaction);
    }
    if (message.reactionSelected !== undefined) {
      obj.reactionSelected = message.reactionSelected;
    }
    if (message.appliedReactions?.length) {
      obj.appliedReactions = message.appliedReactions.map((e) => MessageAppliedReaction.toJSON(e));
    }
    if (message.placedStickers?.length) {
      obj.placedStickers = message.placedStickers.map((e) => MessagePlacedSticker.toJSON(e));
    }
    if (message.chatGuids?.length) {
      obj.chatGuids = message.chatGuids;
    }
    return obj;
  },

  create(base?: DeepPartial<Message>): Message {
    return Message.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Message>): Message {
    const message = createBaseMessage();
    message.guid = object.guid ?? "";
    message.content = (object.content !== undefined && object.content !== null)
      ? MessageContent.fromPartial(object.content)
      : undefined;
    message.subject = object.subject ?? undefined;
    message.dateCreated = object.dateCreated ?? undefined;
    message.dateRead = object.dateRead ?? undefined;
    message.dateDelivered = object.dateDelivered ?? undefined;
    message.dateEdited = object.dateEdited ?? undefined;
    message.dateRetracted = object.dateRetracted ?? undefined;
    message.datePlayed = object.datePlayed ?? undefined;
    message.dateExpressiveSendPlayed = object.dateExpressiveSendPlayed ?? undefined;
    message.sender = (object.sender !== undefined && object.sender !== null)
      ? SingleServiceAddressInfo.fromPartial(object.sender)
      : undefined;
    message.isFromMe = object.isFromMe ?? false;
    message.isSent = object.isSent ?? false;
    message.isDelivered = object.isDelivered ?? false;
    message.isDeliveredQuietly = object.isDeliveredQuietly ?? false;
    message.didNotifyRecipient = object.didNotifyRecipient ?? false;
    message.sendErrorCode = object.sendErrorCode ?? 0;
    message.isAudioMessage = object.isAudioMessage ?? false;
    message.isAutoReply = object.isAutoReply ?? false;
    message.isSystemMessage = object.isSystemMessage ?? false;
    message.isForward = object.isForward ?? false;
    message.isDelayed = object.isDelayed ?? false;
    message.isSpam = object.isSpam ?? false;
    message.dataDetectorResultsPresent = object.dataDetectorResultsPresent ?? false;
    message.isArchived = object.isArchived ?? false;
    message.isServiceMessage = object.isServiceMessage ?? false;
    message.isCorrupt = object.isCorrupt ?? false;
    message.isExpirable = object.isExpirable ?? false;
    message.shareStatus = object.shareStatus ?? undefined;
    message.shareDirection = object.shareDirection ?? undefined;
    message.itemType = object.itemType ?? 0;
    message.groupTitle = object.groupTitle ?? undefined;
    message.chatActionType = object.chatActionType ?? undefined;
    message.threadOriginatorGuid = object.threadOriginatorGuid ?? undefined;
    message.threadOriginatorPart = object.threadOriginatorPart ?? undefined;
    message.replyToGuid = object.replyToGuid ?? undefined;
    message.replyTargetGuid = object.replyTargetGuid ?? undefined;
    message.destinationCallerId = object.destinationCallerId ?? undefined;
    message.partCount = object.partCount ?? undefined;
    message.cachedRoomNames = object.cachedRoomNames ?? undefined;
    message.reactionTargetGuid = object.reactionTargetGuid ?? undefined;
    message.reactionTargetPartIndex = object.reactionTargetPartIndex ?? undefined;
    message.reaction = (object.reaction !== undefined && object.reaction !== null)
      ? MessageReaction.fromPartial(object.reaction)
      : undefined;
    message.reactionSelected = object.reactionSelected ?? undefined;
    message.appliedReactions = object.appliedReactions?.map((e) => MessageAppliedReaction.fromPartial(e)) || [];
    message.placedStickers = object.placedStickers?.map((e) => MessagePlacedSticker.fromPartial(e)) || [];
    message.chatGuids = object.chatGuids?.map((e) => e) || [];
    return message;
  },
};

function createBaseEmbeddedMedia(): EmbeddedMedia {
  return { data: new Uint8Array(0), mimeType: "" };
}

export const EmbeddedMedia: MessageFns<EmbeddedMedia> = {
  encode(message: EmbeddedMedia, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data.length !== 0) {
      writer.uint32(10).bytes(message.data);
    }
    if (message.mimeType !== "") {
      writer.uint32(18).string(message.mimeType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EmbeddedMedia {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmbeddedMedia();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.mimeType = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EmbeddedMedia {
    return {
      data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(0),
      mimeType: isSet(object.mimeType)
        ? globalThis.String(object.mimeType)
        : isSet(object.mime_type)
        ? globalThis.String(object.mime_type)
        : "",
    };
  },

  toJSON(message: EmbeddedMedia): unknown {
    const obj: any = {};
    if (message.data.length !== 0) {
      obj.data = base64FromBytes(message.data);
    }
    if (message.mimeType !== "") {
      obj.mimeType = message.mimeType;
    }
    return obj;
  },

  create(base?: DeepPartial<EmbeddedMedia>): EmbeddedMedia {
    return EmbeddedMedia.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EmbeddedMedia>): EmbeddedMedia {
    const message = createBaseEmbeddedMedia();
    message.data = object.data ?? new Uint8Array(0);
    message.mimeType = object.mimeType ?? "";
    return message;
  },
};

function createBaseMessageReceived(): MessageReceived {
  return { message: undefined };
}

export const MessageReceived: MessageFns<MessageReceived> = {
  encode(message: MessageReceived, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== undefined) {
      Message.encode(message.message, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessageReceived {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessageReceived();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = Message.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessageReceived {
    return { message: isSet(object.message) ? Message.fromJSON(object.message) : undefined };
  },

  toJSON(message: MessageReceived): unknown {
    const obj: any = {};
    if (message.message !== undefined) {
      obj.message = Message.toJSON(message.message);
    }
    return obj;
  },

  create(base?: DeepPartial<MessageReceived>): MessageReceived {
    return MessageReceived.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MessageReceived>): MessageReceived {
    const message = createBaseMessageReceived();
    message.message = (object.message !== undefined && object.message !== null)
      ? Message.fromPartial(object.message)
      : undefined;
    return message;
  },
};

function createBaseMessageEdited(): MessageEdited {
  return { messageGuid: "", content: undefined, editedAt: undefined };
}

export const MessageEdited: MessageFns<MessageEdited> = {
  encode(message: MessageEdited, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.messageGuid !== "") {
      writer.uint32(10).string(message.messageGuid);
    }
    if (message.content !== undefined) {
      MessageContent.encode(message.content, writer.uint32(18).fork()).join();
    }
    if (message.editedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.editedAt), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessageEdited {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessageEdited();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.messageGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.content = MessageContent.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.editedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessageEdited {
    return {
      messageGuid: isSet(object.messageGuid)
        ? globalThis.String(object.messageGuid)
        : isSet(object.message_guid)
        ? globalThis.String(object.message_guid)
        : "",
      content: isSet(object.content) ? MessageContent.fromJSON(object.content) : undefined,
      editedAt: isSet(object.editedAt)
        ? fromJsonTimestamp(object.editedAt)
        : isSet(object.edited_at)
        ? fromJsonTimestamp(object.edited_at)
        : undefined,
    };
  },

  toJSON(message: MessageEdited): unknown {
    const obj: any = {};
    if (message.messageGuid !== "") {
      obj.messageGuid = message.messageGuid;
    }
    if (message.content !== undefined) {
      obj.content = MessageContent.toJSON(message.content);
    }
    if (message.editedAt !== undefined) {
      obj.editedAt = message.editedAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<MessageEdited>): MessageEdited {
    return MessageEdited.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MessageEdited>): MessageEdited {
    const message = createBaseMessageEdited();
    message.messageGuid = object.messageGuid ?? "";
    message.content = (object.content !== undefined && object.content !== null)
      ? MessageContent.fromPartial(object.content)
      : undefined;
    message.editedAt = object.editedAt ?? undefined;
    return message;
  },
};

function createBaseMessageRead(): MessageRead {
  return { messageGuid: "", readAt: undefined };
}

export const MessageRead: MessageFns<MessageRead> = {
  encode(message: MessageRead, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.messageGuid !== "") {
      writer.uint32(10).string(message.messageGuid);
    }
    if (message.readAt !== undefined) {
      Timestamp.encode(toTimestamp(message.readAt), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessageRead {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessageRead();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.messageGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.readAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessageRead {
    return {
      messageGuid: isSet(object.messageGuid)
        ? globalThis.String(object.messageGuid)
        : isSet(object.message_guid)
        ? globalThis.String(object.message_guid)
        : "",
      readAt: isSet(object.readAt)
        ? fromJsonTimestamp(object.readAt)
        : isSet(object.read_at)
        ? fromJsonTimestamp(object.read_at)
        : undefined,
    };
  },

  toJSON(message: MessageRead): unknown {
    const obj: any = {};
    if (message.messageGuid !== "") {
      obj.messageGuid = message.messageGuid;
    }
    if (message.readAt !== undefined) {
      obj.readAt = message.readAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<MessageRead>): MessageRead {
    return MessageRead.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MessageRead>): MessageRead {
    const message = createBaseMessageRead();
    message.messageGuid = object.messageGuid ?? "";
    message.readAt = object.readAt ?? undefined;
    return message;
  },
};

function createBaseMessageUnsent(): MessageUnsent {
  return { messageGuid: "", retractedAt: undefined };
}

export const MessageUnsent: MessageFns<MessageUnsent> = {
  encode(message: MessageUnsent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.messageGuid !== "") {
      writer.uint32(10).string(message.messageGuid);
    }
    if (message.retractedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.retractedAt), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessageUnsent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessageUnsent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.messageGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.retractedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessageUnsent {
    return {
      messageGuid: isSet(object.messageGuid)
        ? globalThis.String(object.messageGuid)
        : isSet(object.message_guid)
        ? globalThis.String(object.message_guid)
        : "",
      retractedAt: isSet(object.retractedAt)
        ? fromJsonTimestamp(object.retractedAt)
        : isSet(object.retracted_at)
        ? fromJsonTimestamp(object.retracted_at)
        : undefined,
    };
  },

  toJSON(message: MessageUnsent): unknown {
    const obj: any = {};
    if (message.messageGuid !== "") {
      obj.messageGuid = message.messageGuid;
    }
    if (message.retractedAt !== undefined) {
      obj.retractedAt = message.retractedAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<MessageUnsent>): MessageUnsent {
    return MessageUnsent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MessageUnsent>): MessageUnsent {
    const message = createBaseMessageUnsent();
    message.messageGuid = object.messageGuid ?? "";
    message.retractedAt = object.retractedAt ?? undefined;
    return message;
  },
};

function createBaseMessageReactionAdded(): MessageReactionAdded {
  return { messageGuid: "", targetPartIndex: undefined, reaction: undefined };
}

export const MessageReactionAdded: MessageFns<MessageReactionAdded> = {
  encode(message: MessageReactionAdded, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.messageGuid !== "") {
      writer.uint32(10).string(message.messageGuid);
    }
    if (message.targetPartIndex !== undefined) {
      writer.uint32(16).int32(message.targetPartIndex);
    }
    if (message.reaction !== undefined) {
      MessageReaction.encode(message.reaction, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessageReactionAdded {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessageReactionAdded();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.messageGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.targetPartIndex = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.reaction = MessageReaction.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessageReactionAdded {
    return {
      messageGuid: isSet(object.messageGuid)
        ? globalThis.String(object.messageGuid)
        : isSet(object.message_guid)
        ? globalThis.String(object.message_guid)
        : "",
      targetPartIndex: isSet(object.targetPartIndex)
        ? globalThis.Number(object.targetPartIndex)
        : isSet(object.target_part_index)
        ? globalThis.Number(object.target_part_index)
        : undefined,
      reaction: isSet(object.reaction) ? MessageReaction.fromJSON(object.reaction) : undefined,
    };
  },

  toJSON(message: MessageReactionAdded): unknown {
    const obj: any = {};
    if (message.messageGuid !== "") {
      obj.messageGuid = message.messageGuid;
    }
    if (message.targetPartIndex !== undefined) {
      obj.targetPartIndex = Math.round(message.targetPartIndex);
    }
    if (message.reaction !== undefined) {
      obj.reaction = MessageReaction.toJSON(message.reaction);
    }
    return obj;
  },

  create(base?: DeepPartial<MessageReactionAdded>): MessageReactionAdded {
    return MessageReactionAdded.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MessageReactionAdded>): MessageReactionAdded {
    const message = createBaseMessageReactionAdded();
    message.messageGuid = object.messageGuid ?? "";
    message.targetPartIndex = object.targetPartIndex ?? undefined;
    message.reaction = (object.reaction !== undefined && object.reaction !== null)
      ? MessageReaction.fromPartial(object.reaction)
      : undefined;
    return message;
  },
};

function createBaseMessageReactionRemoved(): MessageReactionRemoved {
  return { messageGuid: "", targetPartIndex: undefined, reaction: undefined };
}

export const MessageReactionRemoved: MessageFns<MessageReactionRemoved> = {
  encode(message: MessageReactionRemoved, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.messageGuid !== "") {
      writer.uint32(10).string(message.messageGuid);
    }
    if (message.targetPartIndex !== undefined) {
      writer.uint32(16).int32(message.targetPartIndex);
    }
    if (message.reaction !== undefined) {
      MessageReaction.encode(message.reaction, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessageReactionRemoved {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessageReactionRemoved();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.messageGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.targetPartIndex = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.reaction = MessageReaction.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessageReactionRemoved {
    return {
      messageGuid: isSet(object.messageGuid)
        ? globalThis.String(object.messageGuid)
        : isSet(object.message_guid)
        ? globalThis.String(object.message_guid)
        : "",
      targetPartIndex: isSet(object.targetPartIndex)
        ? globalThis.Number(object.targetPartIndex)
        : isSet(object.target_part_index)
        ? globalThis.Number(object.target_part_index)
        : undefined,
      reaction: isSet(object.reaction) ? MessageReaction.fromJSON(object.reaction) : undefined,
    };
  },

  toJSON(message: MessageReactionRemoved): unknown {
    const obj: any = {};
    if (message.messageGuid !== "") {
      obj.messageGuid = message.messageGuid;
    }
    if (message.targetPartIndex !== undefined) {
      obj.targetPartIndex = Math.round(message.targetPartIndex);
    }
    if (message.reaction !== undefined) {
      obj.reaction = MessageReaction.toJSON(message.reaction);
    }
    return obj;
  },

  create(base?: DeepPartial<MessageReactionRemoved>): MessageReactionRemoved {
    return MessageReactionRemoved.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MessageReactionRemoved>): MessageReactionRemoved {
    const message = createBaseMessageReactionRemoved();
    message.messageGuid = object.messageGuid ?? "";
    message.targetPartIndex = object.targetPartIndex ?? undefined;
    message.reaction = (object.reaction !== undefined && object.reaction !== null)
      ? MessageReaction.fromPartial(object.reaction)
      : undefined;
    return message;
  },
};

function createBaseStickerPlaced(): StickerPlaced {
  return { messageGuid: "", targetPartIndex: undefined, sticker: undefined, placement: undefined };
}

export const StickerPlaced: MessageFns<StickerPlaced> = {
  encode(message: StickerPlaced, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.messageGuid !== "") {
      writer.uint32(10).string(message.messageGuid);
    }
    if (message.targetPartIndex !== undefined) {
      writer.uint32(16).int32(message.targetPartIndex);
    }
    if (message.sticker !== undefined) {
      AttachmentInfo.encode(message.sticker, writer.uint32(26).fork()).join();
    }
    if (message.placement !== undefined) {
      StickerPlacement.encode(message.placement, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StickerPlaced {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStickerPlaced();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.messageGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.targetPartIndex = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sticker = AttachmentInfo.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.placement = StickerPlacement.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StickerPlaced {
    return {
      messageGuid: isSet(object.messageGuid)
        ? globalThis.String(object.messageGuid)
        : isSet(object.message_guid)
        ? globalThis.String(object.message_guid)
        : "",
      targetPartIndex: isSet(object.targetPartIndex)
        ? globalThis.Number(object.targetPartIndex)
        : isSet(object.target_part_index)
        ? globalThis.Number(object.target_part_index)
        : undefined,
      sticker: isSet(object.sticker) ? AttachmentInfo.fromJSON(object.sticker) : undefined,
      placement: isSet(object.placement) ? StickerPlacement.fromJSON(object.placement) : undefined,
    };
  },

  toJSON(message: StickerPlaced): unknown {
    const obj: any = {};
    if (message.messageGuid !== "") {
      obj.messageGuid = message.messageGuid;
    }
    if (message.targetPartIndex !== undefined) {
      obj.targetPartIndex = Math.round(message.targetPartIndex);
    }
    if (message.sticker !== undefined) {
      obj.sticker = AttachmentInfo.toJSON(message.sticker);
    }
    if (message.placement !== undefined) {
      obj.placement = StickerPlacement.toJSON(message.placement);
    }
    return obj;
  },

  create(base?: DeepPartial<StickerPlaced>): StickerPlaced {
    return StickerPlaced.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StickerPlaced>): StickerPlaced {
    const message = createBaseStickerPlaced();
    message.messageGuid = object.messageGuid ?? "";
    message.targetPartIndex = object.targetPartIndex ?? undefined;
    message.sticker = (object.sticker !== undefined && object.sticker !== null)
      ? AttachmentInfo.fromPartial(object.sticker)
      : undefined;
    message.placement = (object.placement !== undefined && object.placement !== null)
      ? StickerPlacement.fromPartial(object.placement)
      : undefined;
    return message;
  },
};

function createBaseMessageChangeEvent(): MessageChangeEvent {
  return {
    chatGuid: "",
    occurredAt: undefined,
    actor: undefined,
    isFromMe: false,
    messageReceived: undefined,
    messageEdited: undefined,
    messageRead: undefined,
    messageUnsent: undefined,
    reactionAdded: undefined,
    reactionRemoved: undefined,
    stickerPlaced: undefined,
  };
}

export const MessageChangeEvent: MessageFns<MessageChangeEvent> = {
  encode(message: MessageChangeEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.occurredAt !== undefined) {
      Timestamp.encode(toTimestamp(message.occurredAt), writer.uint32(18).fork()).join();
    }
    if (message.actor !== undefined) {
      SingleServiceAddressInfo.encode(message.actor, writer.uint32(26).fork()).join();
    }
    if (message.isFromMe !== false) {
      writer.uint32(32).bool(message.isFromMe);
    }
    if (message.messageReceived !== undefined) {
      MessageReceived.encode(message.messageReceived, writer.uint32(82).fork()).join();
    }
    if (message.messageEdited !== undefined) {
      MessageEdited.encode(message.messageEdited, writer.uint32(90).fork()).join();
    }
    if (message.messageRead !== undefined) {
      MessageRead.encode(message.messageRead, writer.uint32(98).fork()).join();
    }
    if (message.messageUnsent !== undefined) {
      MessageUnsent.encode(message.messageUnsent, writer.uint32(106).fork()).join();
    }
    if (message.reactionAdded !== undefined) {
      MessageReactionAdded.encode(message.reactionAdded, writer.uint32(114).fork()).join();
    }
    if (message.reactionRemoved !== undefined) {
      MessageReactionRemoved.encode(message.reactionRemoved, writer.uint32(122).fork()).join();
    }
    if (message.stickerPlaced !== undefined) {
      StickerPlaced.encode(message.stickerPlaced, writer.uint32(130).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessageChangeEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessageChangeEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.occurredAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.actor = SingleServiceAddressInfo.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isFromMe = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.messageReceived = MessageReceived.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.messageEdited = MessageEdited.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.messageRead = MessageRead.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.messageUnsent = MessageUnsent.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.reactionAdded = MessageReactionAdded.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.reactionRemoved = MessageReactionRemoved.decode(reader, reader.uint32());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.stickerPlaced = StickerPlaced.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessageChangeEvent {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      occurredAt: isSet(object.occurredAt)
        ? fromJsonTimestamp(object.occurredAt)
        : isSet(object.occurred_at)
        ? fromJsonTimestamp(object.occurred_at)
        : undefined,
      actor: isSet(object.actor) ? SingleServiceAddressInfo.fromJSON(object.actor) : undefined,
      isFromMe: isSet(object.isFromMe)
        ? globalThis.Boolean(object.isFromMe)
        : isSet(object.is_from_me)
        ? globalThis.Boolean(object.is_from_me)
        : false,
      messageReceived: isSet(object.messageReceived)
        ? MessageReceived.fromJSON(object.messageReceived)
        : isSet(object.message_received)
        ? MessageReceived.fromJSON(object.message_received)
        : undefined,
      messageEdited: isSet(object.messageEdited)
        ? MessageEdited.fromJSON(object.messageEdited)
        : isSet(object.message_edited)
        ? MessageEdited.fromJSON(object.message_edited)
        : undefined,
      messageRead: isSet(object.messageRead)
        ? MessageRead.fromJSON(object.messageRead)
        : isSet(object.message_read)
        ? MessageRead.fromJSON(object.message_read)
        : undefined,
      messageUnsent: isSet(object.messageUnsent)
        ? MessageUnsent.fromJSON(object.messageUnsent)
        : isSet(object.message_unsent)
        ? MessageUnsent.fromJSON(object.message_unsent)
        : undefined,
      reactionAdded: isSet(object.reactionAdded)
        ? MessageReactionAdded.fromJSON(object.reactionAdded)
        : isSet(object.reaction_added)
        ? MessageReactionAdded.fromJSON(object.reaction_added)
        : undefined,
      reactionRemoved: isSet(object.reactionRemoved)
        ? MessageReactionRemoved.fromJSON(object.reactionRemoved)
        : isSet(object.reaction_removed)
        ? MessageReactionRemoved.fromJSON(object.reaction_removed)
        : undefined,
      stickerPlaced: isSet(object.stickerPlaced)
        ? StickerPlaced.fromJSON(object.stickerPlaced)
        : isSet(object.sticker_placed)
        ? StickerPlaced.fromJSON(object.sticker_placed)
        : undefined,
    };
  },

  toJSON(message: MessageChangeEvent): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.occurredAt !== undefined) {
      obj.occurredAt = message.occurredAt.toISOString();
    }
    if (message.actor !== undefined) {
      obj.actor = SingleServiceAddressInfo.toJSON(message.actor);
    }
    if (message.isFromMe !== false) {
      obj.isFromMe = message.isFromMe;
    }
    if (message.messageReceived !== undefined) {
      obj.messageReceived = MessageReceived.toJSON(message.messageReceived);
    }
    if (message.messageEdited !== undefined) {
      obj.messageEdited = MessageEdited.toJSON(message.messageEdited);
    }
    if (message.messageRead !== undefined) {
      obj.messageRead = MessageRead.toJSON(message.messageRead);
    }
    if (message.messageUnsent !== undefined) {
      obj.messageUnsent = MessageUnsent.toJSON(message.messageUnsent);
    }
    if (message.reactionAdded !== undefined) {
      obj.reactionAdded = MessageReactionAdded.toJSON(message.reactionAdded);
    }
    if (message.reactionRemoved !== undefined) {
      obj.reactionRemoved = MessageReactionRemoved.toJSON(message.reactionRemoved);
    }
    if (message.stickerPlaced !== undefined) {
      obj.stickerPlaced = StickerPlaced.toJSON(message.stickerPlaced);
    }
    return obj;
  },

  create(base?: DeepPartial<MessageChangeEvent>): MessageChangeEvent {
    return MessageChangeEvent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MessageChangeEvent>): MessageChangeEvent {
    const message = createBaseMessageChangeEvent();
    message.chatGuid = object.chatGuid ?? "";
    message.occurredAt = object.occurredAt ?? undefined;
    message.actor = (object.actor !== undefined && object.actor !== null)
      ? SingleServiceAddressInfo.fromPartial(object.actor)
      : undefined;
    message.isFromMe = object.isFromMe ?? false;
    message.messageReceived = (object.messageReceived !== undefined && object.messageReceived !== null)
      ? MessageReceived.fromPartial(object.messageReceived)
      : undefined;
    message.messageEdited = (object.messageEdited !== undefined && object.messageEdited !== null)
      ? MessageEdited.fromPartial(object.messageEdited)
      : undefined;
    message.messageRead = (object.messageRead !== undefined && object.messageRead !== null)
      ? MessageRead.fromPartial(object.messageRead)
      : undefined;
    message.messageUnsent = (object.messageUnsent !== undefined && object.messageUnsent !== null)
      ? MessageUnsent.fromPartial(object.messageUnsent)
      : undefined;
    message.reactionAdded = (object.reactionAdded !== undefined && object.reactionAdded !== null)
      ? MessageReactionAdded.fromPartial(object.reactionAdded)
      : undefined;
    message.reactionRemoved = (object.reactionRemoved !== undefined && object.reactionRemoved !== null)
      ? MessageReactionRemoved.fromPartial(object.reactionRemoved)
      : undefined;
    message.stickerPlaced = (object.stickerPlaced !== undefined && object.stickerPlaced !== null)
      ? StickerPlaced.fromPartial(object.stickerPlaced)
      : undefined;
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from((globalThis as any).Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return (globalThis as any).Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
